import {
	MonitoringFeedEntrySchema,
	type MonitoringFeedEntry,
} from '#app/routes/mocra+/_form+/components/monitoring-feeds/schema.ts'
import {
	collectMonitoringFeedErrors,
	createMonitoringFeedDraft,
	monitoringFeedDraftToEntry,
	monitoringFeedEntryToDraft,
	sanitizeMonitoringFeedDraft,
	type MonitoringFeedDraft,
} from '#app/routes/mocra+/_form+/components/monitoring-feeds/types.ts'
import { assertEntityDefinition } from '#app/routes/mocra+/_form+/entity-definition.ts'

export const monitoringFeedDefinition = assertEntityDefinition<
	MonitoringFeedEntry,
	MonitoringFeedDraft
>({
	schema: MonitoringFeedEntrySchema,
	createDraft: () => createMonitoringFeedDraft(),
	sanitizeDraft: sanitizeMonitoringFeedDraft,
	serialize: monitoringFeedDraftToEntry,
	deserialize: monitoringFeedEntryToDraft,
	collectErrors: collectMonitoringFeedErrors,
})

export type MonitoringFeedEntityDraft = MonitoringFeedDraft
